// extracted by mini-css-extract-plugin
export default {"SideLinkWrapper":"SideLink_SideLinkWrapper__Y1--L","SideLink":"SideLink_SideLink__9t6iR"};